import {BOOKLISTS_FETCHED} from "../types";

export default function AllBooklists(state = {}, action = {}) {
    switch (action.type) {
        case BOOKLISTS_FETCHED:
            return action.data;
        default:
            return state
    }
}